// @flow
import React from 'react';
import {Field, reduxForm} from 'redux-form';
import SelectFormInput from '../SelectFormInput/SelectFormInput';
import TextAreaFormInput from '../TextAreaFormInput/TextAreaFormInput';
import DecimalFormInput from '../DecimalFormInput/DecimalFormInput';
import _ from 'lodash/fp';

const filterByRoomTypeId = (roomId, rooms, products) => {
  const room = _.find({id: roomId}, rooms);
  return !!room
    ? _.filter(p => !p.roomTypes.length || _.some({id: room.roomTypeId}, p.roomTypes), products)
    : products;
};

const productVariantByRoomTypeId = (roomId, rooms, products) => {
  const room = _.find({id: roomId}, rooms);

  const productList = !!room
    ? _.filter(p => p.archived === null && (!p.roomTypes.length || _.some({id: room.roomTypeId}, p.roomTypes)), products)
    : products;

  const combined = _.flatMap(p => {
    const notArchived = _.filter(
      pv => pv.archived === null,
      p.variants
    );

    return _.map(pv => ({key: pv.id, item: pv, name: `${p.name} - ${pv.name}`}), notArchived);
  }, productList);

  return _.sortBy(['name'], combined);
};

export type Props = {
  existingRows: any[],
  products: any[],
  variants: any[],
  rooms: any[],
  activeRow: any,
  formValues: ?any,
  change: Function,
  onSelectProduct: Function,
  combineProduct: Boolean
};

const ProductRowForm = ({
  activeRow,
  products,
  variants,
  rooms,
  existingRows,
  change,
  onSelectProduct,
  formValues,
  combineProduct,
}: Props) => (
  <div>
    <Field
      name="roomId"
      label="Rum"
      disabled={!!activeRow.id}
      normalize={value => {
        const id = value ? value.id : null;
        change('product', null);
        change('productVariant', null);
        change('productCombo', null);
        return id;
      }}
      component={SelectFormInput}
      valueKey="id"
      labelKey="name"
      options={rooms} />

    {formValues && formValues.roomId &&
    <div>
      { combineProduct ?
        <Field
          name="productVariant"
          label="Produkt Variant"
          disabled={!!activeRow.id}
          normalize={value => {
            return value.item;
          }}
          component={SelectFormInput}
          valueKey="key"
          labelKey="name"
          options={productVariantByRoomTypeId(formValues.roomId, rooms, products)} />
        :
        <div>
          <Field
            name="product"
            label="Produkt"
            disabled={!!activeRow.id}
            normalize={value => {
              const id = value ? value.id : null;
              change('productVariant', null);
              onSelectProduct(id);
              return value;
            }}
            component={SelectFormInput}
            valueKey="id"
            labelKey="name"
            options={filterByRoomTypeId(formValues.roomId, rooms, products)} />

          <Field
            name="productVariant"
            label="Variant"
            disabled={!!activeRow.id || !formValues || !formValues.product}
            component={SelectFormInput}
            valueKey="id"
            labelKey="name"
            options={_.map(v => ({
              ...v,
              disabled: !!formValues && !!formValues.roomId && _.some({
                productVariantId: v.id,
                roomId: formValues.roomId,
              }, existingRows),
            }), variants) } />
        </div>
      }

      <Field
        name="quantity"
        label="Antal"
        component={DecimalFormInput} />

      <Field
        name="note"
        label="Anteckning"
        component={TextAreaFormInput} />
    </div>
    }
  </div>
);

export default reduxForm({
  form: 'productRow',
  enableReinitialize: true,
})(ProductRowForm);



// WEBPACK FOOTER //
// ./src/components/ProductRowForm/ProductRowForm.js